export default __webpack_public_path__ + "static/media/banner-appointment.3c6a1324.png";